import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "",
  description:
    "Consider the acoustic-mechanical system shown below and see how to obtain its equivalent electrical network. A diaphragm of mass Mm, compliance Cm and mechanical resistance Rm is mounted on an acoustic resonator. The system is mounted between two very large, planar, rigid baffles.",
  theory: theory,
  layout: {
    type: "buttonsToggle",
    options: {
      controlsPosition: "bottom",
      labels: [
        [
          {
            name: "Problem geometry",
          },
          {
            name: "Electrical analogies",
          },
          {
            name: "Mechanical and acoustical domains",
          },
          {
            name: "Acoustical domain",
          },
        ],
      ],
      components: [
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "image",
              options: {
                src: `${config.ASSETS_URL}/04/11/principle/problem-geometry.svg`,
              },
            },
          },
        },
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "image",
              options: {
                src: `${config.ASSETS_URL}/04/11/principle/electrical-analogies.svg`,
              },
            },
          },
        },
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "image",
              options: {
                src: `${config.ASSETS_URL}/04/11/principle/mechanical-and-acoustical-domains.svg`,
              },
            },
          },
        },
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "image",
              options: {
                src: `${config.ASSETS_URL}/04/11/principle/acoustical-domain.svg`,
              },
            },
          },
        },
      ],
    },
  },
};

export default principle;
